import './Styles/global.less';
import './Files';

import './Setup';
import './Components';

import { default as context } from '@truckdown/systems';
import { IAppUserContext } from './IAppUserContext';

export type { IAppUserContext };
export type { IIconLoader } from './IIconLoader';
export type { INavItem } from './INavItem';
export type { NotificationReceivedHandler } from './Setup/NotificationReceivedHandler';

export { Constants as SystemConstants } from './constants';
export default context as IAppUserContext;